module.exports = __webpack_public_path__ + "static/media/YF93_3.8e6127d6.jpg";